import { createContext } from "react";

import { Cart } from "@/types/cart";

export type CartContextType = {
  cart?: Cart;
  setCart: (cart?: Cart) => void;
  showCart: boolean;
  setShowCart: (showCart: boolean) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  error?: string | null;
  refetchCart: () => void;
};

export const CartContext = createContext<CartContextType>({
  setCart: () => {},
  showCart: false,
  setShowCart: () => {},
  loading: false,
  setLoading: () => {},
  error: null,
  refetchCart: () => {},
});
